import { render, staticRenderFns } from "./Async.vue?vue&type=template&id=dc84aebc"
import script from "./Async.vue?vue&type=script&lang=js"
export * from "./Async.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports